import React, { useState, useContext, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button,
  Typography } from '@mui/material';
import ErrorDialog from '../ErrorDialog';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContextProvider';
import { Link } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import { getTZDateTimeAsString } from '../utils/DateUtils';
import '../App.css';

const ClassList = () => {
  const [events, setEvents] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  
  useEffect(() => {
    const fetchEvents = async () => {
      let date = new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
      const params = {
        shownOn : {$gt: date},
        _site: { $in: [null, undefined] }, // matches null or missing
        _owner: { $ne: null }  
      };
      rpc({
        method: "GetScheduledEvents",
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: onSuccess
      });
    }; 
    fetchEvents();
  }, []);
  
  const onSuccess = (events) => {
    setEvents(events.filter(e => e._event !== null));
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const onCreate= () => {
    navigate('/createClass');
  };

  const getEventGroups = (event) => {
    return event._eventGroups.map((group) => {
      return `${group._site.name} ${group.displayName}`;
    }).join(', ');
  };


  return (
    <div className="ClassList">
      <Typography variant="h6" gutterBottom>
        Classes
      </Typography>
      <TableContainer className="TableContainer" component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell><b>Title</b></TableCell>
              <TableCell><b>Shown On</b></TableCell>
              <TableCell><b>Event</b></TableCell>
              <TableCell><b>Groups</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event, index) => (
              <TableRow key={index}>
                <TableCell>{`${event.title}`}</TableCell>
                <TableCell>
                  <Link to={`/classDetails/${event._id}`}>{getTZDateTimeAsString(event.shownOn, user._site.timezone)}</Link>
                </TableCell>
                <TableCell>{`${event._event.displayName}`}</TableCell>
                <TableCell>{getEventGroups(event)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Button className="Button" variant="contained" color="primary" onClick={onCreate}>
        Schedule Class
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default ClassList;
